import App from "../App/App.js";
import config from "./_config.json";
var apiEndpoint = App.Env.Api + config.stock;

export default {
  getExport(params) {
    const attributes = ["warehouse", "haslastinvoicedate", "hasqty", "hasnoqty",
      "search", "field"];
    const urlParams = App.Out.getParams(params, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/export" + urlParams
    };
  },
  getList(params) {
    const attributes = ["warehouse", "haslastinvoicedate", "hasqty", "hasnoqty",
      "search", "field"];
    const urlParams = App.Out.getParams(params, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/list" + urlParams
    };
  },
  getListData(params) {
    const attributes = ["warehouse", "haslastinvoicedate", "hasqty", "hasnoqty",
      "search", "field"];
    const urlParams = App.Out.getParams(params, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/listdata" + urlParams
    };
  },
  getPrintData(params) {
    const attributes = ["warehouse", "haslastinvoicedate", "hasqty", "hasnoqty",
      "search", "field"];
    const urlParams = App.Out.getParams(params, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/printdata" + urlParams
    };
  }
}